import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: ${CSSVars.white};
  padding: 70px 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 90px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 110px 40px;
  }

  .inner {
    max-width: 820px;
    margin: 0 auto;
  }

  header {
    text-align: center;
    margin-bottom: 40px;

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      margin-bottom: 56px;
    }
  }

  .eyebrow {
    display: inline-block;
    background: rgba(76, 79, 255, 0.08);
    color: ${CSSVars.blue500};
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 6px 12px;
    border-radius: 999px;
    margin-bottom: 14px;
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 30px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: ${CSSVars.black};
    margin: 0;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 40px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 48px;
    }
  }

  .list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .item {
    background: ${CSSVars.white};
    border: 1px solid ${CSSVars.gray100};
    border-radius: 14px;
    overflow: hidden;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &.open {
      border-color: rgba(76, 79, 255, 0.3);
      box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
    }

    &:hover:not(.open) {
      border-color: ${CSSVars.gray200};
    }
  }

  .question {
    width: 100%;
    background: transparent;
    border: 0;
    text-align: left;
    cursor: pointer;
    padding: 20px 22px;
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    color: ${CSSVars.black};
    letter-spacing: -0.005em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 17px;
      padding: 22px 26px;
    }

    &:focus-visible {
      outline: 2px solid ${CSSVars.blue500};
      outline-offset: -2px;
    }
  }

  .chevron {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    border-right: 2px solid #6b7280;
    border-bottom: 2px solid #6b7280;
    transform: rotate(45deg);
    transition: transform 0.25s ease, border-color 0.25s ease;
    margin-bottom: 4px;
  }

  .open .chevron {
    transform: rotate(-135deg);
    border-color: ${CSSVars.blue500};
    margin-bottom: -4px;
  }

  .answer {
    padding: 0 22px 22px;
    animation: slideDown 0.2s ease;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      padding: 0 26px 24px;
    }

    p {
      font-family: ${CSSVars.secondaryFont};
      font-weight: 400;
      font-size: 15px;
      line-height: 1.65;
      color: #4b5563;
      margin: 0;
      max-width: 700px;
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
